export const info = {
  desc: [
    "Hi!",
    "As You may know by now, my name is Agnieszka Nowacka. I am an architect + an architecture student.",
    "My architecture history begun 5 years ago at the Lodz University of Technology. After many wonderful experiences and adventures, including Erasmus exchange in Spain, internship in Finland, expeditions to Ukraine and Dubai, I have completed my Bachelors Degree there. Through this time I have worked in two architecture studios and also managed small-scaled projects on my own. I am now attending Master Degree of Architecture at the Warsaw University of Technology.",
    "It may be quite easy to notice that I love traveling and getting new perspectives. I also relish painting, slow walks in forests and learning new “useless” skills (although no skill is truly useless). <u>Below you can see a gallery of a few things I enjoy.</u>",
    "Feel free to wander through the projects on this webpage and contact me for any additional information.",
    "Thank you for your time!",
    "Agnieszka",
  ],
  imgs: [
    {
      title: "Watching nature",
      src: "/info/Watching nature.jpg",
    },
    {
      title: "Taking photos on the walks",
      src: "/info/Shoting photos on the walks.jpg",
    },
    {
      title: "Forest",
      src: "/info/Forests.jpg",
    },
    {
      title: "Forest",
      src: "/info/Forests2.jpg",
    },
    {
      title: "Mountains",
      src: "/info/Mountains.jpg",
    },
    {
      title: "Painting",
      src: "/info/Painting.jpg",
    },
    {
      title: "Painting",
      src: "/info/Painting 2.jpg",
    },
    {
      title: "Painting",
      src: "/info/Painting 4.jpg",
    },

    {
      title: "Illustration",
      src: "/info/Illustration.jpg",
    },
    {
      title: "Illustration",
      src: "/info/Illustration1.jpg",
    },

    {
      title: "Painting",
      src: "/info/Painting 3.jpg",
    },
    {
      title: "Painting",
      src: "/info/Painting 5.jpg",
    },
  ],
};
